import type { StoryblokRichTextNode } from "@storyblok/react";
import type { FC, ReactElement } from "react";
import TabContent from "./components/TabContent/TabContent";
import TabGroup from "./components/TabGroup";
import type { TabGroupTabsProps } from "./components/TabGroup/TabGroup";
import * as s from "./Tabs.module.scss";

type TabsProps = {
	tabs: TabGroupTabsProps;
	selectedTabIndex: number;
	setSelectedTabIndex: (id: number) => void;
	ariaLabelScroll?: string;
};

const Tabs: FC<TabsProps> = ({
	tabs,
	ariaLabelScroll,
	selectedTabIndex,
	setSelectedTabIndex,
}) => {
	const selectHandler = (id: number) => {
		if (tabs[id]) setSelectedTabIndex(id);
	};

	return (
		<div className={s.tabWrapper}>
			{tabs.length > 1 && (
				<TabGroup
					selectedTabIndex={selectedTabIndex}
					setSelectedTabIndex={selectHandler}
					tabLabels={tabs.map((tab) => tab.label)}
					ariaLabelScroll={ariaLabelScroll ?? "Scroll"}
				/>
			)}
			<TabContent
				header={tabs[selectedTabIndex]?.header}
				content={
					tabs[selectedTabIndex]?.richtext as
						| StoryblokRichTextNode<ReactElement>
						| undefined
				}
				cta={tabs[selectedTabIndex]?.cta}
			/>
		</div>
	);
};

export default Tabs;
